import {
  getResponsiveLengthPropControllerDataResponsiveLengthData
} from "@makeswift/prop-controllers";
function useResponsiveLengthPropControllerData(data) {
  if (data == null)
    return data;
  return getResponsiveLengthPropControllerDataResponsiveLengthData(data);
}
export {
  useResponsiveLengthPropControllerData
};
//# sourceMappingURL=useResponsiveLengthPropControllerData.js.map